import React, { useCallback, useState } from 'react';
import EtfSymbolQuickView from './EtfSymbolQuickView';

interface Props {
  symbol: string;
  sleeveKey?: string;
  className?: string;
}

const EtfSymbolLink: React.FC<Props> = ({ symbol, sleeveKey, className = '' }) => {
  const [open, setOpen] = useState(false);
  const normalized = symbol?.trim().toUpperCase();
  const isTicker = normalized && normalized !== '—' && /^[A-Z][A-Z0-9.-]{0,9}$/.test(normalized);

  const onClick = useCallback(
    (e: React.MouseEvent) => {
      if (!isTicker) return;
      e.preventDefault();
      e.stopPropagation();
      setOpen(true);
    },
    [isTicker],
  );

  if (!isTicker) {
    return <span className={className}>{symbol}</span>;
  }

  return (
    <>
      <button
        type="button"
        onClick={onClick}
        className={`font-medium text-primary-600 underline decoration-primary-300 underline-offset-2 hover:text-primary-800 hover:decoration-primary-500 ${className}`}
        title={`View ${normalized} quote and links`}
      >
        {normalized}
      </button>
      {open ? (
        <EtfSymbolQuickView
          symbol={normalized}
          sleeveKey={sleeveKey}
          onClose={() => setOpen(false)}
        />
      ) : null}
    </>
  );
};

export default EtfSymbolLink;
